// components
import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Dialog } from 'components/shared/index';
import { RecurrenceDialogProps } from './RecurrenceDialog.types';

// hooks
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// types
import { AppointmentRecurrenceType } from '../../../../mrp/components/AppointmentForm/AppointmentForm.types';

// styles
import { ContentContainer } from './RecurrenceDialog.styles';
import { ActionsContainer } from '../styles';

export const RecurrenceDialog = ({
  open,
  onClose,
  onOpen,
  actionType = 'update'
}: RecurrenceDialogProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });
  const [value, setValue] = useState<AppointmentRecurrenceType | null>(null);

  useEffect(() => {
    open && onOpen?.();
  }, [open]);

  return (
    <Dialog
      handleClose={onClose?.bind(null, undefined)}
      open={open}
      title={t('dialogs.recurrence.title', {
        action: t(`dialogs.recurrence.actions.${actionType}`)
      })}
    >
      <ContentContainer>
        <RadioGroup
          aria-labelledby="recurrence-radio-buttons-group"
          onChange={(_, value) => setValue(value as AppointmentRecurrenceType)}
        >
          <FormControlLabel
            value={AppointmentRecurrenceType.ONLY_THIS}
            control={<Radio />}
            label={t('onlyThis')}
          />
          <FormControlLabel
            value={AppointmentRecurrenceType.THIS_AND_ALL_SUBSEQUENT}
            control={<Radio />}
            label={t('thisAndSubsequentAppointments')}
          />
        </RadioGroup>

        <ActionsContainer>
          <Button
            variant="text"
            fullWidth
            onClick={onClose?.bind(null, undefined)}
          >
            {t('dialogs.recurrence.cancel')}
          </Button>

          <Button
            disabled={!value}
            fullWidth
            onClick={onClose?.bind(null, { editAppointmentType: value! })}
          >
            {t('dialogs.recurrence.confirm')}
          </Button>
        </ActionsContainer>
      </ContentContainer>
    </Dialog>
  );
};
